// TODO: перенести в модуль photo
export interface Multimedia {
  file: File;
  source?: MultimediaSource;
}

// TODO: перенести в модуль photo
export interface MultimediaSource {
  data?: string;
  src?: string;
  mimeType?: string;
}
